import { all, takeLatest } from "redux-saga/effects";
import {
  FAQ_LIST,
  DETAIL_FAQ,
  CREATE_FAQ,
  UPDATE_FAQ,
  DELETE_FAQ,
} from "../actions/faq.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getFaqList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "faqs/list",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* faqDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `faqs/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* createFaq({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "faqs",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateFaq({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `faqs/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteFaq({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `faqs/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* Faq() {
  yield all([
    takeLatest(FAQ_LIST, getFaqList),
    takeLatest(DETAIL_FAQ, faqDetails),
    takeLatest(CREATE_FAQ, createFaq),
    takeLatest(UPDATE_FAQ, updateFaq),
    takeLatest(DELETE_FAQ, deleteFaq),
  ]);
}

export default Faq;
